import {
  Box,
  Paper,
  IconButton,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  Pagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Icon,
} from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";
import DeleteIcon from "@mui/icons-material/Delete";
import { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";

import { LayoutBaseDePagina } from "../../shared/layouts";
import { FerramentaDeDetalhe } from "../../shared/components";
import { Api, IPaginacao } from "../../shared/services/api/axios-config";
import {
  EtiquetaService,
  IEstante,
} from "../../shared/services/api/Etiqueta/EtiquetaService";
import { Environment } from "../../shared/environment";

export const CodigoBarras: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const [isLoading, setIsLoading] = useState(false);
  const [rows, setRows] = useState<IEstante[]>([]);

  const [busca, setBusca] = useState("");
  const [erroBusca, setErroBusca] = useState(false);

  const [openModalGerar, setOpenModalGerar] = useState(false);
  const [quantidade, setQuantidade] = useState(1);

  const [openDialogExcluir, setOpenDialogExcluir] = useState(false);
  const [idExcluir, setIdExcluir] = useState<number | null>(null);

  const [paginacao, setPaginacao] = useState<IPaginacao>({
    totalCount: 0,
    pageSize: 0,
    currentPage: 0,
    totalPages: 0,
    hasNext: false,
    hasPrevious: false,
  });

  const pagina = useMemo(() => {
    return Number(searchParams.get("pagina") || "1");
  }, [searchParams]);

  const carregarCodigos = async () => {
  setPaginacao({
    totalCount: 0,
    pageSize: 0,
    currentPage: 0,
    totalPages: 0,
    hasNext: false,
    hasPrevious: false,
  });
  setRows([]);
  try {
    setIsLoading(true);

    const result = await EtiquetaService.listarCodigosBarras(
      pagina,
      true,
      busca
    );

    if (result instanceof Error) throw result;

    setRows(result.estante);
    setPaginacao(result.paginacao);

    setErroBusca(result.estante.length === 0 && busca.length > 0);
  } 
  catch (error: any) {
    console.error("Erro ao carregar códigos de barras:", error);
  } 
  finally {
    setIsLoading(false);
  }
};
  const reimprimir = async (idCoord: number) => {
    try {
      setIsLoading(true);
      await EtiquetaService.reimprimir(idCoord);
    } catch (error: any) {
      console.error("Erro ao reimprimir código de barras:", error);
    }
    finally {
      setIsLoading(false);
    }
  };

  const confirmarExcluir = (id: number) => {
    setIdExcluir(id);
    setOpenDialogExcluir(true);
  };

  const excluir = async () => {
    if (idExcluir === null) return;

    try {
      setIsLoading(true);
      const result = await EtiquetaService.excluirCodigoBarras([idExcluir]);
      if (result instanceof Error) throw result;

      setOpenDialogExcluir(false);
      carregarCodigos();
    } catch (error: any) {
      console.error("Erro ao excluir código de barras:", error);
    }
    finally {
      setIsLoading(false);
    }
  };

  const gerarCodigos = async () => {
    try {
      setIsLoading(true);
      const result = await EtiquetaService.gerarCodigoBarras(quantidade);
      if (result instanceof Error) throw result;
      setOpenModalGerar(false);
      carregarCodigos();
    } catch (error: any) {
      console.error("Erro ao gerar códigos de barras:", error);
    }
    finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
  carregarCodigos();
}, [pagina, busca]);

  return (
    <LayoutBaseDePagina
      titulo="Códigos de Barras"
      barraDeFerramentas={
        <FerramentaDeDetalhe
          mostrarBotaoSalvar={false}
          mostrarBotaoApagar={false}
          mostrarBotaoVoltar={false}
          mostrarBarraDeBusca={true}
          placeholderBarraDeBusca="Buscar código de barras"
          valorBarraDeBusca={busca}
          erroBarraDeBusca={erroBusca}
          aoAlterarBarraDeBusca={(texto) => {setBusca(texto)
          setSearchParams({ pagina: "1" }, { replace: true })}}
          aoClicarEmNovo={() => setOpenModalGerar(true)}
        />
      }
    >
      <TableContainer
        component={Paper}
        variant="outlined"
        sx={{ m: 1, width: "auto" }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>#</TableCell>
              <TableCell>Código de Barras</TableCell>
              <TableCell>Ações</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.map((row, index) => (
              <TableRow key={row.idCoord}>
                <TableCell>{((pagina - 1) * Environment.LIMITE_DE_LINHAS) + (index + 1)} </TableCell>
                <TableCell>{row.codigoBarras}</TableCell>
                <TableCell>
                  <IconButton onClick={() => reimprimir(row.idCoord)}>
                    <PrintIcon />
                  </IconButton>
                  <IconButton onClick={() => confirmarExcluir(row.idCoord)}>
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>

          {paginacao.totalCount === 0 && !isLoading && (
            <caption>{Environment.LISTAGEM_VAZIA}</caption>
          )}

          <TableFooter>
            {isLoading && (
              <TableRow>
                <TableCell colSpan={3} sx={{ p: 0 }}>
                  <LinearProgress />
                </TableCell>
              </TableRow>
            )}

            {paginacao.totalPages > 1 && (
              <TableRow>
                <TableCell colSpan={3} align="right">
                  <Box flexDirection="row" display="inline-flex">
                    <Pagination
                      page={pagina}
                      count={paginacao.totalPages}
                      onChange={(_, page) =>
                        setSearchParams(
                          { pagina: page.toString() },
                          { replace: true },
                        )
                      }
                    />
                  </Box>
                </TableCell>
              </TableRow>
            )}
          </TableFooter>
        </Table>
      </TableContainer>

      <Dialog open={openModalGerar} onClose={() => setOpenModalGerar(false)}>
        <DialogTitle>Gerar códigos de barras</DialogTitle>
        <DialogContent dividers>
          <TextField
            autoFocus
            margin="dense"
            label="Quantidade"
            type="number"
            fullWidth
            value={quantidade}
            inputProps={{ min: 1 }}
            onChange={(e) => setQuantidade(Math.max(1, Number(e.target.value)))}
          />
        </DialogContent>
        <DialogActions>
          <Box
            width="100%"
            marginX={1}
            padding={1}
            paddingX={2}
            gap={1}
            display="flex"
            justifyContent="center"
          >
            <Button
              variant="contained"
              color="error"
              startIcon={<Icon>close</Icon>}
              onClick={() => setOpenModalGerar(false)}
            >
              <Typography variant="button" noWrap>
                {" "}
                Fechar{" "}
              </Typography>
            </Button>
            <Button
              variant="contained"
              startIcon={<Icon>check</Icon>}
              onClick={gerarCodigos}
              disabled={isLoading}
            >
              <Typography variant="button" noWrap>
                {" "}
                Confirmar{" "}
              </Typography>
            </Button>
          </Box>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openDialogExcluir}
        onClose={() => setOpenDialogExcluir(false)}
      >
        <DialogTitle>Confirmar exclusão</DialogTitle>
        <DialogContent>
          <Typography>
            Deseja realmente excluir este código de barras?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{ color: "#fff" }}
            onClick={() => setOpenDialogExcluir(false)}
          >
            Cancelar
          </Button>
          <Button color="error" variant="contained" onClick={excluir}>
            Excluir
          </Button>
        </DialogActions>
      </Dialog>
    </LayoutBaseDePagina>
  );
};

export default CodigoBarras;
